module.exports = __webpack_public_path__ + "static/media/bird_picking_sticks.ef76ee41.png";